"use strict";

var scrollAnimate = require("../components/scrollAnimate");
var setClearButtonPosition = require("../components/setClearButtonPosition");
var setEyeButtonPosition = require("../components/setClearButtonPosition");

/**
 * Remove all validation. Should be called every time before revalidating form
 * @param {element} form - Form to be cleared
 * @returns {void}
 */
function clearFormErrors(form) {
    $(form).find(".form-control.is-invalid").removeClass("is-invalid");
}

module.exports = function (formElement, payload) {
    // clear form validation first
    clearFormErrors(formElement);
    $(".alert", formElement).remove();

    if (typeof payload === "object" && payload.fields) {
        Object.keys(payload.fields).forEach(function (key) {
            if (payload.fields[key]) {
                var feedbackElement = $(formElement).find("[name=\"" + key + "\"]")
                    .parent()
                    .children(".invalid-feedback");

                if (feedbackElement.length > 0) {
                    if (Array.isArray(payload[key])) {
                        feedbackElement.html(payload.fields[key].join("<br/>"));
                    } else {
                        feedbackElement.html(payload.fields[key]);
                    }

                    feedbackElement.siblings(".form-control").addClass("is-invalid");
                    scrollAnimate($(".invalid-feedback")[0]);
                    setEyeButtonPosition();

                    const $inputParent = feedbackElement.closest("form");

                    if ($inputParent.hasClass("c-form__clear-fields") && window.mqRespond.status.lgDown) {
                        const $formGroup = feedbackElement.closest(".form-group");
                        const $inputField = $("*[name=" + key + "]", $formGroup);

                        setClearButtonPosition($inputField);
                    }
                }
            }
        });
    }
    if (payload && payload.error) {
        var $formElement = $(formElement);
        var form = $formElement.prop("tagName") === "FORM"
            ? $formElement
            : $formElement.parents("form");

        form.prepend("<div class=\"alert alert-danger c-error-message clearfix\" role=\"alert\">"
            + "<div class=\"float-left\">" + "<svg class=\"svg-inline icon-close-light icon-close-light-red\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" aria-hidden=\"true\" width=\"16\" height=\"16\"><path d=\"M1.01-.01l15 15m-15 0l15-15M1.722-.112l15 15m-15 0l15-15\" fill=\"none\" stroke=\"#fff\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M1.01.89l14.102 14.1m-14.102 0L15.112.89\" fill=\"none\" stroke=\"#ca2f2f\" stroke-width=\"1.88\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg>"
            + "</div>" + "<p class=\"m-0 text-error display-inline float-left\">" + payload.error + "</p>" + "</div>");
    }
};
